export class SearchDeviceInfo {
  public imei = "";
  public make = "";
  public model = "";
  public modelId = "";
  public purchasePrice = null;
  public purchaseDate = "";
  public invoiceNumber = "";
  public isImei = "yes";
  public isUpload = "yes";
  public isSerialNumber = "";
  public serialNumber = "";
  public DealerShipProgramType = "";
  public EquipmentRiskType = "";
  public Equipment = "";
  public Barcode = "";
}
